import { defaultIconProps, IconProps } from './IconProps';

export const IconPlay: import('react').FC<IconProps> = ({ color, ...rest }) => (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M1.16666 1.5L12.8333 9L1.16666 16.5V1.5Z" stroke={color} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconPlay.defaultProps = defaultIconProps;
